const random = Math.floor(Math.random() * 10000)
// 权限数据管理
const requestBaseData = {
  code: 0,
  reasonCode: 0,
  requestId: '1234567890',
  msg: 'success',
  time: new Date().getTime(),
  requiredVersion: {
    merchantWeb: '1.0.0',
    clientWeb: '1.0.0'
  },
}
const authMockResponses = {
  /**
   * @description 应用安装
   */
  '/api/brand/v1/installShopifyShop': {
    ...requestBaseData,
    data: {
      shopifyShopId: '1234567890',
      shopifyShopName: 'willdesk-somini',
      shopifyShopUrl: 'https://willdesk-somini.myshopify.com',
      shopifyShopAccessToken: 'shpat_xxx_mock_token_for_testing_xxx',
      shopifyShopOwner: 'Test Store Owner',
      shopifyShopEmail: 'test@example.com',
    }
  },
  /**
   * @description 授权回调处理
   */
  '/api/auth/callback': {
    ...requestBaseData,
    data: {
      shopifyShopId: '1234567890',
      shopifyShopName: 'willdesk-somini',
      shopifyShopUrl: 'https://willdesk-somini.myshopify.com',
      shopifyShopAccessToken: 'shpat_xxx_mock_token_for_testing_xxx',
      shopifyShopOwner: 'Test Store Owner',
      shopifyShopEmail: 'test@example.com',
    }
  },
  /**
   * @description B端用户登录鉴权
   */
  '/api/brand/v1/system/buserAuth': {
    ...requestBaseData,
    data: {
      token: `mock_token_${random}`, // 令牌
      expiresAt: new Date().getTime() + 86400000, // 过期时间戳 (1天后)
    }
  },
  /**
   * @description 获取当前B端用户详情
   */
  '/api/brand/v1/buser/getCurrentBuser': {
    ...requestBaseData,
    data: {
      actived: true, // 是否已激活
      buserId: 10001, // 用户ID
      email: 'merchant@example.com', // 邮箱
      profile: `https://www.gravatar.com/avatar/${random}`, // 头像
      role: 'admin', // 角色
      username: '测试商家账号', // 用户名
      workLang: 'zh-CN' // 工作语言
    }
  },
  /**
   * @description 获取店铺列表详情
   */
  '/api/brand/v1/shop/getShopList': {
    ...requestBaseData,
    data: {
      shopList: [
        {
          id: 1001, // 店铺id
          orgId: 101, // 组织Id
          brandId: 201, // 品牌id
          shopName: 'WillDesk测试店铺1', // 店铺名称
          shopDomain: 'shop1.myshopify.com', // 店铺shopify域名
          source: 'shopify', // 店铺来源
          email: 'shop1@example.com', // 店铺邮箱
          useDays: 30, // 使用天数
          installTime: new Date().toISOString(), // 安装时间
          embeddingSwitch: true, // 是否开启embedding
          embeddingUrl: 'https://shop1.myshopify.com/embedding', // embedding url
          scopePass: true, // 是否完整授权
          scopeUrl: 'https://shop1.myshopify.com/admin/oauth' // 授权url
        },
        {
          id: 1002, // 店铺id
          orgId: 101, // 组织Id
          brandId: 201, // 品牌id
          shopName: 'WillDesk测试店铺2', // 店铺名称
          shopDomain: 'shop2.myshopify.com', // 店铺shopify域名
          source: 'shopify', // 店铺来源
          email: 'shop2@example.com', // 店铺邮箱
          useDays: 15, // 使用天数
          installTime: new Date().toISOString(), // 安装时间
          embeddingSwitch: false, // 是否开启embedding
          embeddingUrl: '', // embedding url
          scopePass: false, // 是否完整授权
          scopeUrl: 'https://shop2.myshopify.com/admin/oauth' // 授权url
        }
      ],
      brandInfo: {
        brandId: 201, // 品牌Id
        orgId: 101, // 组织Id
        brandName: 'WillDesk测试品牌', // 品牌名称
        stepStatus: {
          dismiss: false, // 是否忽略安装引导
          stepList: [
            {
              stepKey: 'stepKeyEnableAppEmbed', // 启用AppEmbed
              status: 2 // 已完成
            },
            {
              stepKey: 'stepKeySetStyleWidget', // 设置Style Widget
              status: 1 // 部分完成
            },
            {
              stepKey: 'stepKeyCustomizeHelpCenter', // 定制帮助中心
              status: 0 // 未开始
            }
          ]
        }
      }
    }
  }
}

export default authMockResponses;
